import { useMemo } from 'react';
import { useCurrencyContext } from '~/contexts/Currencies';
import useJourneyData from '~/hooks/useJourneyData';
import { useCurrentJourneyTotal } from '~/stores/journeyStore';
import { formatGBP } from '~/utils/currencyHelpers';
import { pricePerPerson } from '~/utils/paxHelpers';

const PricePerPerson = () => {
  const {
    details: { totalPrice },
    user,
    journeyType
  } = useJourneyData();
  const updatedTotal = useCurrentJourneyTotal();
  const { convertPriceInGBP } = useCurrencyContext();

  const isTemplate = journeyType === 'asTemplate';
  const { numberOfAdults, adult_count, childAges } = user;

  const adults = isTemplate ? numberOfAdults : adult_count;
  const price = updatedTotal || totalPrice;

  const perPerson = useMemo(() => pricePerPerson(price, adults, childAges), [price, adults, childAges]);

  const convertedPrice = convertPriceInGBP(perPerson);
  const displayPrice = convertedPrice || formatGBP(perPerson);

  return <>{displayPrice}</>;
};

export { PricePerPerson };
